module.exports = __webpack_public_path__ + "static/media/upcoming-bookings-icon.ff3a14d3.webp";